import axios from 'axios';

const resolveToken = (token) => token || sessionStorage.getItem('token');

const buildAuthConfig = (token, contentType) => {
  const resolvedToken = resolveToken(token);
  const headers = {
    Authorization: `Bearer ${resolvedToken}`,
  };

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return { headers };
};

export const getManagerBoards = async ({ page = 1, limit = 10, search = '' } = {}, token) => {
  const res = await axios.get('/api/manager-board', {
    params: { page, limit, search },
    ...buildAuthConfig(token),
  });
  return res.data;
};

export const getManagerBoard = async (id, token) => {
  const res = await axios.get(`/api/manager-board/${id}`, buildAuthConfig(token));
  return res.data;
};

export const createManagerBoard = async (data, token) => {
  const isFormData = data instanceof FormData;
  const res = await axios.post(
    '/api/manager-board',
    data,
    buildAuthConfig(token, isFormData ? 'multipart/form-data' : 'application/json')
  );
  return res.data;
};

export const updateManagerBoard = async (id, data, token) => {
  const isFormData = data instanceof FormData;
  const res = await axios.put(
    `/api/manager-board/${id}`,
    data,
    buildAuthConfig(token, isFormData ? 'multipart/form-data' : 'application/json')
  );
  return res.data;
};

export const deleteManagerBoard = async (id, token) => {
  const res = await axios.delete(`/api/manager-board/${id}`, buildAuthConfig(token));
  return res.data;
};

export const uploadManagerBoardFiles = async (id, files, token) => {
  const formData = new FormData();
  (files || []).forEach((file) => {
    formData.append('files', file);
  });

  const res = await axios.post(
    `/api/manager-board/${id}/files`,
    formData,
    buildAuthConfig(token, 'multipart/form-data')
  );
  return res.data;
};
